import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MapLocationsService {

  constructor(private http: HttpClient) { }

  getMapLocations() {
    return this.http.get(window.location.origin + '/api/maplocations');
  }

}
